/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-west-2',
  aws_content_delivery_bucket: 'threepp-hosting-bucket-us-west-2-336892131278-devfour',
  aws_content_delivery_bucket_region: 'us-west-2',
  aws_content_delivery_url: 'https://d2xcvpvann3in1.cloudfront.net',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_lC9kz8u7d',
  aws_user_pools_web_client_id: '32c63mj8r26448kp85pva5qk0u',
  oauth: {
    domain: 'engage-sso-devfour.auth.us-west-2.amazoncognito.com',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/logout/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 10,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_appsync_graphqlEndpoint: 'https://lsm3ipj5u5dhtfd2xmxhorkj4q.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_user_files_s3_bucket: 'threepp-initial-upload-us-west-2-336892131278-devfour',
  aws_user_files_s3_bucket_region: 'us-west-2',
  aws_dynamodb_all_tables_region: 'us-west-2',
  aws_dynamodb_table_schemas: [{}, {}, {}, {}],
};

export default awsmobile;
